var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cc-cluster-type-select"},_vm._l((_vm.deployEnvList),function(env){return _c('a-button',{key:env.cloudOrIdcName,attrs:{"type":env.cloudOrIdcName === _vm.selectedClusterEnv ? 'primary': 'default'},on:{"click":function($event){return _vm.handleSelectClusterEnv(env.cloudOrIdcName)}}},[_vm._v(" "+_vm._s(env.i18nName)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }